import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { TECHNICAL_SHEET_OVERRIDE_PROCESS } from '../types/technical-sheet-override-process.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for TechnicalSheetOverrideProcess.
 * Subcollection: org/{orgId}/technical-sheet-override/{overrideId}/process
 *
 * Resolve with context: { orgId, overrideId }.
 */
export const technicalSheetOverrideProcessDescriptor = {
    name: TECHNICAL_SHEET_OVERRIDE_PROCESS,
    label: 'Processo do Override',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/technical-sheet-override/{overrideId}/process',
    pathPatternKeys: { orgId: 'string', overrideId: 'string' },
    version: 1,
    description: 'Processo adicionado, removido ou com instrução alterada pelo override de ficha técnica',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        // NoCache: filho de entidade versionada (spec 0045) — itens em cache voltariam velhos após Recarregar e seriam regravados por cima.
        cache: CacheStrategy.NoCache,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        { name: 'id', label: 'ID', type: 'string', required: true },
        { name: 'action', label: 'Ação', type: 'string', required: true },
        { name: 'processId', label: 'Processo', type: 'string', required: true },
        { name: 'order', label: 'Ordem', type: 'number', required: false },
        {
            name: 'processInstructions',
            label: 'Instruções de processo',
            type: 'string',
            required: false,
            // Same cap as ProductionOrderStep / route processInstructions (FIELD_LIMITS.DESCRIPTION).
            maxLength: FIELD_LIMITS.DESCRIPTION,
            description: 'ADD: instrução do processo incluído; UPDATE: substitui a instrução do processo existente',
        },
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        {
            fieldName: 'processId',
            targetEntity: 'Process',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Processo alvo/incluído',
        },
        ...AUDIT_FOREIGN_KEYS,
    ],
};
//# sourceMappingURL=technical-sheet-override-process.descriptor.js.map